import React, { useState } from "react";
import TaskReaction from "./TaskReaction";
import TaskReactionMessage from "./TaskReactionMessage";
import TaskCommentList from "./TaskCommentList";
import MoreMenuOption from "./MoreMenuOption";
import { ReactComponent as ChatIcon } from "assets/img/icons/comment.svg";
import { useMoodsContext } from "store/contexts/moodsContext";
import { useLocation } from "react-router-dom";
import { useTimelineContext } from "store/contexts/timelineContext";

export default ({ listTask }) => {
  const { moods } = useMoodsContext();
  const { selectTodoListItem } = useTimelineContext();
  const search = useLocation().search;
  const param = new URLSearchParams(search);
  const expression_id = param.get("expression_id");
  const [expressionsOpen, setExpressionsOpen] = useState(
    expression_id ? true : false
  );

  const handleExpressionClick = () => {
    if (selectTodoListItem) {
      return selectTodoListItem(listTask);
    }
    setExpressionsOpen(!expressionsOpen);
  };

  return (
    <>
      <TaskReactionMessage
        listTask={listTask}
        openEngagement={handleExpressionClick}
      />
      <div className="post-footer">
        <div className="post-actions">
          <div className="left-actions">
            {Boolean(moods) && Boolean(moods.length) && (
              <TaskReaction listTask={listTask} />
            )}
            <span className="p-comment-btn" onClick={handleExpressionClick}>
              <ChatIcon className="mwh-15" style={{ fill: "#6c737e" }} />{" "}
              Comment
            </span>
          </div>
          <MoreMenuOption listTask={listTask} />
        </div>
      </div>
      {expressionsOpen && !selectTodoListItem && (
        <TaskCommentList listTask={listTask} />
      )}
    </>
  );
};
